import { render, staticRenderFns } from "./VerifyCheck.vue?vue&type=template&id=d1037c68&scoped=true"
import script from "./VerifyCheck.vue?vue&type=script&lang=js"
export * from "./VerifyCheck.vue?vue&type=script&lang=js"
import style0 from "./VerifyCheck.vue?vue&type=style&index=0&id=d1037c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1037c68",
  null
  
)

export default component.exports